module.exports = __webpack_public_path__ + "img/checkbox-selv2.0a9eec52.svg";